export const TOUR_SELECTORS = {
  sidebar: '[data-tour="tour-sidebar"]',
  setupChecklist: '[data-tour="tour-setup-checklist"]',
  loanCta: '[data-tour="tour-loan-cta"]',
  quickActions: '[data-tour="tour-quick-actions"]',
  profile: '[data-tour="tour-profile"]',
  // Staff contributions
  staffContribMember: '[data-tour="staff-contrib-member"]',
  staffContribLines: '[data-tour="staff-contrib-lines"]',
  staffContribSave: '[data-tour="staff-contrib-save"]',
  // Staff loans
  staffLoanHeader: '[data-tour="staff-loan-status-header"]',
  staffLoanTabs: '[data-tour="staff-loan-status-tabs"]',
  staffLoanTable: '[data-tour="staff-loan-status-table"]',
  // Member contributions
  memberContribRecord: '[data-tour="member-contrib-record-cta"]',
  memberContribSavings: '[data-tour="member-contrib-savings"]',
  memberContribHistory: '[data-tour="member-contrib-history"]',
  // Member loans
  memberLoanApply: '[data-tour="member-loan-apply"]',
  memberLoanStatus: '[data-tour="member-loan-status-card"]',
  memberLoanRepay: '[data-tour="member-loan-repay-card"]',
  // Staff members
  staffMembersHeader: '[data-tour="staff-members-header"]',
  staffMembersSearch: '[data-tour="staff-members-search"]',
  staffMembersTable: '[data-tour="staff-members-table"]',
  // Member attendance
  memberAttendanceSummary: '[data-tour="member-attendance-summary"]',
  memberAttendanceFines: '[data-tour="member-attendance-fines"]',
  memberAttendanceHistory: '[data-tour="member-attendance-history"]',
  // Staff attendance
  staffAttendanceHeader: '[data-tour="staff-attendance-header"]',
  staffAttendanceCalendar: '[data-tour="staff-attendance-calendar"]',
  staffAttendanceMarking: '[data-tour="staff-attendance-marking"]',
  // Member profile
  memberProfileEdit: '[data-tour="member-profile-edit"]',
  memberProfileIdentity: '[data-tour="member-profile-identity"]',
  memberProfileTabs: '[data-tour="member-profile-tabs"]',
  // Staff settings / staff mgmt / communication
  staffSettingsHeader: '[data-tour="staff-settings-header"]',
  staffSettingsAdd: '[data-tour="staff-settings-add"]',
  staffSettingsTable: '[data-tour="staff-settings-table"]',
  staffStaffHeader: '[data-tour="staff-staff-header"]',
  staffStaffSearch: '[data-tour="staff-staff-search"]',
  staffStaffTable: '[data-tour="staff-staff-table"]',
  staffCommCompose: '[data-tour="staff-comm-compose"]',
  staffCommGroups: '[data-tour="staff-comm-groups"]',
  staffCommSummary: '[data-tour="staff-comm-summary"]',
  // Staff engagement
  staffEventsList: '[data-tour="staff-events-list"]',
  staffEventsCreate: '[data-tour="staff-events-create"]',
  staffBdayToday: '[data-tour="staff-bday-today"]',
  staffBdayWish: '[data-tour="staff-bday-wish"]',
  staffEminutesList: '[data-tour="staff-eminutes-list"]',
  staffEminutesCreate: '[data-tour="staff-eminutes-create"]',
  // Staff finance / support / audit / reports
  staffTxnFilters: '[data-tour="staff-txn-filters"]',
  staffTxnTable: '[data-tour="staff-txn-table"]',
  staffTxnExport: '[data-tour="staff-txn-export"]',
  staffSupportForm: '[data-tour="staff-support-form"]',
  staffSupportSave: '[data-tour="staff-support-save"]',
  staffAuditFilters: '[data-tour="staff-audit-filters"]',
  staffAuditTable: '[data-tour="staff-audit-table"]',
  staffReportsFilters: '[data-tour="staff-reports-filters"]',
  staffReportsTable: '[data-tour="staff-reports-table"]',
  // Member remaining coop
  memberBdayList: '[data-tour="member-bday-list"]',
  memberBdayWish: '[data-tour="member-bday-wish"]',
  memberTxnFilters: '[data-tour="member-txn-filters"]',
  memberTxnTable: '[data-tour="member-txn-table"]',
  memberMsgInbox: '[data-tour="member-msg-inbox"]',
  memberMsgOpen: '[data-tour="member-msg-open"]',
  memberEventsCal: '[data-tour="member-events-cal"]',
  memberEventsUpcoming: '[data-tour="member-events-upcoming"]',
  memberSupportContact: '[data-tour="member-support-contact"]',
  memberSupportInstructions: '[data-tour="member-support-instructions"]',
  memberEminutesList: '[data-tour="member-eminutes-list"]',
  memberEminutesOpen: '[data-tour="member-eminutes-open"]',
  // Shared invest (investor + member)
  investOppsCatalogue: '[data-tour="invest-opps-catalogue"]',
  investOppsCard: '[data-tour="invest-opps-card"]',
  investMarketGrid: '[data-tour="invest-market-grid"]',
  investMarketOrder: '[data-tour="invest-market-order"]',
  investRequestsTabs: '[data-tour="invest-requests-tabs"]',
  investRequestsList: '[data-tour="invest-requests-list"]',
  investorNotifList: '[data-tour="investor-notif-list"]',
  investorNotifFilters: '[data-tour="investor-notif-filters"]',
  investorProfileTabs: '[data-tour="investor-profile-tabs"]',
  investorProfileKyc: '[data-tour="investor-profile-kyc"]',
  // Staff Investment Hub
  staffInvestHubCards: '[data-tour="staff-invest-hub-cards"]',
  staffInvestHubAttention: '[data-tour="staff-invest-hub-attention"]',
  staffInvestOppsList: '[data-tour="staff-invest-opps-list"]',
  staffInvestOppsCreate: '[data-tour="staff-invest-opps-create"]',
  staffInvestReqQueue: '[data-tour="staff-invest-req-queue"]',
  staffInvestReqTabs: '[data-tour="staff-invest-req-tabs"]',
  staffInvestKycQueue: '[data-tour="staff-invest-kyc-queue"]',
  staffInvestKycActions: '[data-tour="staff-invest-kyc-actions"]',
};

function isExactPath(pathname, base) {
  return pathname === base || pathname === `${base}/`;
}

export const staffDashboardSteps = [
  {
    element: TOUR_SELECTORS.sidebar,
    popover: {
      title: "Navigate the portal",
      description:
        "Use the sidebar to move between members, contributions, loans, settings, and other cooperative tools.",
      side: "right",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.setupChecklist,
    popover: {
      title: "Finish cooperative setup",
      description:
        "Complete these checklist items — banks, loan types, and other settings — so day-to-day operations run smoothly.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.profile,
    popover: {
      title: "Your profile & logout",
      description:
        "Open this menu anytime to view your profile or sign out securely.",
      side: "bottom",
      align: "end",
    },
  },
];

export const memberDashboardSteps = [
  {
    element: TOUR_SELECTORS.sidebar,
    popover: {
      title: "Navigate the portal",
      description:
        "Use the sidebar to open contributions, loans, events, and other member services.",
      side: "right",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.loanCta,
    popover: {
      title: "Apply for a loan",
      description:
        "Start a loan application from here when you need suitable and affordable financing.",
      side: "top",
      align: "center",
    },
  },
  {
    element: TOUR_SELECTORS.profile,
    popover: {
      title: "Your profile & logout",
      description:
        "Open this menu to view your profile or log out when you are done.",
      side: "bottom",
      align: "end",
    },
  },
];

export const investorDashboardSteps = [
  {
    element: TOUR_SELECTORS.sidebar,
    popover: {
      title: "Navigate the investor portal",
      description:
        "Use the sidebar to open investments, marketplace, requests, KYC, and other investor tools.",
      side: "right",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.quickActions,
    popover: {
      title: "Quick actions",
      description:
        "Jump straight into investments, marketplace, and common tasks from these shortcuts.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.profile,
    popover: {
      title: "Your profile & logout",
      description:
        "Open this menu to manage your profile or sign out when you are done.",
      side: "bottom",
      align: "end",
    },
  },
];

export const staffContributionsSteps = [
  {
    element: TOUR_SELECTORS.staffContribMember,
    popover: {
      title: "Select the member",
      description:
        "Choose which member you are recording a contribution for.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffContribLines,
    popover: {
      title: "Add contribution lines",
      description:
        "Enter category, amount, payment method, and date. Use Add New if you need more than one line.",
      side: "top",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffContribSave,
    popover: {
      title: "Save the record",
      description:
        "Click Save record to review and submit the contribution for this member.",
      side: "top",
      align: "start",
    },
  },
];

export const staffLoansSteps = [
  {
    element: TOUR_SELECTORS.staffLoanHeader,
    popover: {
      title: "Loan status",
      description:
        "This is your loan operations queue — review applications and disbursements here.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffLoanTabs,
    popover: {
      title: "Filter by status",
      description:
        "Switch between Pending, Approved, Declined, Disbursed, and Completed loans.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffLoanTable,
    popover: {
      title: "Take action on a loan",
      description:
        "Open a row’s actions to approve, decline, disburse, or view details and repayment plans.",
      side: "top",
      align: "start",
    },
  },
];

export const memberContributionsSteps = [
  {
    element: TOUR_SELECTORS.memberContribRecord,
    popover: {
      title: "Record a contribution",
      description:
        "Start here to pay a contribution online or by transfer to the society account.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberContribSavings,
    popover: {
      title: "Your savings",
      description:
        "See withdrawable savings and request a withdrawal when you need funds.",
      side: "left",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberContribHistory,
    popover: {
      title: "History & withdrawals",
      description:
        "Review contribution history and track withdrawal requests in these tabs.",
      side: "top",
      align: "start",
    },
  },
];

export const memberLoansSteps = [
  {
    element: TOUR_SELECTORS.memberLoanApply,
    popover: {
      title: "Apply for a loan",
      description:
        "Start a new loan application from here when you need financing.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberLoanStatus,
    popover: {
      title: "Check loan status",
      description:
        "See the progress of loans you have already applied for.",
      side: "left",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberLoanRepay,
    popover: {
      title: "Loan repayments",
      description:
        "Open repayments to pay upcoming, due, or overdue installments.",
      side: "left",
      align: "start",
    },
  },
];

export const staffMembersSteps = [
  {
    element: TOUR_SELECTORS.staffMembersHeader,
    popover: {
      title: "Member list",
      description:
        "This is your cooperative’s member directory for the active branch.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffMembersSearch,
    popover: {
      title: "Find a member",
      description:
        "Search by name, email, phone, or membership number to locate someone quickly.",
      side: "bottom",
      align: "end",
    },
  },
  {
    element: TOUR_SELECTORS.staffMembersTable,
    popover: {
      title: "View and manage members",
      description:
        "Open a row’s actions to view a profile, suspend, or archive. Register new members from Member Registration in the sidebar.",
      side: "top",
      align: "start",
    },
  },
];

export const memberAttendanceSteps = [
  {
    element: TOUR_SELECTORS.memberAttendanceSummary,
    popover: {
      title: "Attendance overview",
      description:
        "See days present, absences, attendance rate, and fine totals at a glance.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberAttendanceFines,
    popover: {
      title: "Pay attendance fines",
      description:
        "If you have unpaid fines, settle them here by card or bank transfer to the society account.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberAttendanceHistory,
    popover: {
      title: "Attendance history",
      description:
        "Filter by date or status, download a report, and review each meeting’s attendance and fines.",
      side: "top",
      align: "start",
    },
  },
];

export const staffAttendanceSteps = [
  {
    element: TOUR_SELECTORS.staffAttendanceHeader,
    popover: {
      title: "Attendance marking",
      description:
        "Mark daily attendance here. Open Fine Settings when you need to review fine amounts.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffAttendanceCalendar,
    popover: {
      title: "Pick a date",
      description:
        "Select the meeting date to load members who still need to be marked.",
      side: "right",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffAttendanceMarking,
    popover: {
      title: "Mark and submit",
      description:
        "Set each member’s status (or Mark all), then Submit attendance. Non-approved absence may apply a fine.",
      side: "top",
      align: "start",
    },
  },
];

export const memberProfileSteps = [
  {
    element: TOUR_SELECTORS.memberProfileEdit,
    popover: {
      title: "Edit your profile",
      description:
        "Update your personal details and photo from here when something changes.",
      side: "bottom",
      align: "end",
    },
  },
  {
    element: TOUR_SELECTORS.memberProfileIdentity,
    popover: {
      title: "Your membership info",
      description:
        "Your name, membership number, and contact details appear in this section.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberProfileTabs,
    popover: {
      title: "Accounts & privacy",
      description:
        "Switch tabs for loans, contributions, savings, bank accounts, and privacy settings.",
      side: "top",
      align: "start",
    },
  },
];

export const staffSettingsSteps = [
  {
    element: TOUR_SELECTORS.staffSettingsHeader,
    popover: {
      title: "Society bank accounts",
      description:
        "These are the cooperative accounts members transfer into. Keep names and numbers accurate.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffSettingsAdd,
    popover: {
      title: "Add a bank account",
      description:
        "Create a new society account when you need another destination for contributions or repayments.",
      side: "bottom",
      align: "end",
    },
  },
  {
    element: TOUR_SELECTORS.staffSettingsTable,
    popover: {
      title: "Account status",
      description:
        "Review each account, enable or disable it, and manage details from the row actions.",
      side: "top",
      align: "start",
    },
  },
];

export const staffStaffMgmtSteps = [
  {
    element: TOUR_SELECTORS.staffStaffHeader,
    popover: {
      title: "Staff directory",
      description:
        "Everyone with portal access for this cooperative appears here.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffStaffSearch,
    popover: {
      title: "Find a staff member",
      description: "Search by name to open a profile or take an action quickly.",
      side: "bottom",
      align: "end",
    },
  },
  {
    element: TOUR_SELECTORS.staffStaffTable,
    popover: {
      title: "Row actions",
      description:
        "View a profile, suspend, or archive a staff account from the actions menu.",
      side: "top",
      align: "start",
    },
  },
];

export const staffCommunicationSteps = [
  {
    element: TOUR_SELECTORS.staffCommCompose,
    popover: {
      title: "Compose and sent mail",
      description:
        "Write a new message, or switch tabs to continue a draft or review what you already sent.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffCommGroups,
    popover: {
      title: "Message groups",
      description:
        "Open Group Management to build recipient lists for SMS and email campaigns.",
      side: "right",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffCommSummary,
    popover: {
      title: "Communication summary",
      description:
        "Check credits, delivery stats, and overall messaging activity from Summary.",
      side: "right",
      align: "start",
    },
  },
];

export const staffEventsSteps = [
  {
    element: TOUR_SELECTORS.staffEventsList,
    popover: {
      title: "Event calendar",
      description:
        "Filter and browse cooperative events. Switch tabs for upcoming, current, or past lists.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffEventsCreate,
    popover: {
      title: "Create an event",
      description:
        "Add a new event so members can see it on their calendar and get reminders.",
      side: "bottom",
      align: "end",
    },
  },
];

export const staffBirthdaySteps = [
  {
    element: TOUR_SELECTORS.staffBdayToday,
    popover: {
      title: "Today’s celebrants",
      description:
        "Members and staff with a birthday today appear here so you can greet them promptly.",
      side: "right",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffBdayWish,
    popover: {
      title: "Send a birthday wish",
      description:
        "Send a personal message now, or create templates for automated wishes.",
      side: "left",
      align: "start",
    },
  },
];

export const staffEminutesSteps = [
  {
    element: TOUR_SELECTORS.staffEminutesCreate,
    popover: {
      title: "Publish minutes",
      description:
        "Create a new e-minute to record meetings and share them with members.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffEminutesList,
    popover: {
      title: "Published minutes",
      description: "Open any record to review or continue editing published minutes.",
      side: "top",
      align: "start",
    },
  },
];

export const staffTransactionsSteps = [
  {
    element: TOUR_SELECTORS.staffTxnFilters,
    popover: {
      title: "Filter transactions",
      description:
        "Search or narrow by type, status, and date to find a specific payment.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffTxnTable,
    popover: {
      title: "Branch activity",
      description:
        "Every recorded payment for this branch appears here. Open a row for full details.",
      side: "top",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffTxnExport,
    popover: {
      title: "Download a report",
      description: "Export the current view as CSV or PDF when you need a copy.",
      side: "bottom",
      align: "end",
    },
  },
];

export const staffSupportSteps = [
  {
    element: TOUR_SELECTORS.staffSupportForm,
    popover: {
      title: "Member support contacts",
      description:
        "Set the email, phone, and instructions members see when they need help.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffSupportSave,
    popover: {
      title: "Save support details",
      description:
        "Publish updates so members get current contact information on their Support page.",
      side: "top",
      align: "center",
    },
  },
];

export const staffAuditSteps = [
  {
    element: TOUR_SELECTORS.staffAuditFilters,
    popover: {
      title: "Filter the audit log",
      description:
        "Narrow by date or action type, including Investment Hub and KYC activity.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffAuditTable,
    popover: {
      title: "Who did what",
      description:
        "Each row is a staff or system action. Open it to inspect metadata and timing.",
      side: "top",
      align: "start",
    },
  },
];

export const staffReportsSteps = [
  {
    element: TOUR_SELECTORS.staffReportsFilters,
    popover: {
      title: "SMS history filters",
      description:
        "Search by phone or filter by source, status, and date to audit outbound SMS.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffReportsTable,
    popover: {
      title: "Delivery log",
      description:
        "Review each message sent from this branch and open a row for delivery details.",
      side: "top",
      align: "start",
    },
  },
];

export const memberBirthdaysSteps = [
  {
    element: TOUR_SELECTORS.memberBdayList,
    popover: {
      title: "Today’s birthdays",
      description:
        "See who in the cooperative is celebrating today. Switch tabs for wishes you received.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberBdayWish,
    popover: {
      title: "Send a wish",
      description: "Tap Send Birthday Wish to greet a member with a personal message.",
      side: "top",
      align: "start",
    },
  },
];

export const memberTransactionsSteps = [
  {
    element: TOUR_SELECTORS.memberTxnFilters,
    popover: {
      title: "Find a payment",
      description:
        "Search or filter by type to locate contributions, loans, fines, and other activity.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberTxnTable,
    popover: {
      title: "Your history",
      description:
        "This is your complete transaction list. Open a row for reference and status details.",
      side: "top",
      align: "start",
    },
  },
];

export const memberMessagesSteps = [
  {
    element: TOUR_SELECTORS.memberMsgInbox,
    popover: {
      title: "Your inbox",
      description:
        "Cooperative messages land here. Switch between all and unread, then filter by channel or date.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberMsgOpen,
    popover: {
      title: "Open a message",
      description: "Select a row to read the full SMS or email the cooperative sent you.",
      side: "top",
      align: "start",
    },
  },
];

export const memberEventsSteps = [
  {
    element: TOUR_SELECTORS.memberEventsCal,
    popover: {
      title: "Your calendar",
      description:
        "Dates with events are highlighted. Tap a day to see what’s happening.",
      side: "left",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberEventsUpcoming,
    popover: {
      title: "Upcoming and past events",
      description:
        "Browse ongoing, upcoming, and past events, and mark whether you can attend.",
      side: "top",
      align: "start",
    },
  },
];

export const memberSupportSteps = [
  {
    element: TOUR_SELECTORS.memberSupportContact,
    popover: {
      title: "Reach your cooperative",
      description:
        "Use the published email or phone when you need help from staff.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberSupportInstructions,
    popover: {
      title: "How to get support",
      description:
        "Follow any extra instructions your cooperative added, such as office hours or what to include.",
      side: "top",
      align: "start",
    },
  },
];

export const memberEminutesSteps = [
  {
    element: TOUR_SELECTORS.memberEminutesList,
    popover: {
      title: "Cooperative minutes",
      description:
        "Official records and announcements from your cooperative appear in this list.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.memberEminutesOpen,
    popover: {
      title: "Read a minute",
      description: "Open any item to read the full published content.",
      side: "top",
      align: "start",
    },
  },
];

export const investInvestmentsSteps = [
  {
    element: TOUR_SELECTORS.investOppsCatalogue,
    popover: {
      title: "Browse opportunities",
      description:
        "Filter by category or risk, then open an offering to review terms and unit price.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.investOppsCard,
    popover: {
      title: "Invest from a card",
      description:
        "View details or submit interest when an opportunity is open. KYC must be approved first.",
      side: "top",
      align: "start",
    },
  },
];

export const investMarketplaceSteps = [
  {
    element: TOUR_SELECTORS.investMarketGrid,
    popover: {
      title: "Marketplace products",
      description:
        "Search or filter the products your cooperative has published.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.investMarketOrder,
    popover: {
      title: "Place an order",
      description:
        "Order from a product card, or open details first. Complete KYC if you are asked to.",
      side: "top",
      align: "end",
    },
  },
];

export const investRequestsSteps = [
  {
    element: TOUR_SELECTORS.investRequestsTabs,
    popover: {
      title: "Request types",
      description:
        "Switch between investments, marketplace orders, property requests, or see everything together.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.investRequestsList,
    popover: {
      title: "Track your requests",
      description:
        "Open any item to see status, payment, and next steps for that request.",
      side: "top",
      align: "start",
    },
  },
];

export const investorNotificationsSteps = [
  {
    element: TOUR_SELECTORS.investorNotifFilters,
    popover: {
      title: "Filter notifications",
      description:
        "Jump between all, unread, and read, or narrow by category such as KYC or investments.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.investorNotifList,
    popover: {
      title: "Your inbox",
      description:
        "Open a notification to act on it, or mark items read so you can stay current.",
      side: "top",
      align: "start",
    },
  },
];

export const investorProfileSteps = [
  {
    element: TOUR_SELECTORS.investorProfileTabs,
    popover: {
      title: "Profile sections",
      description:
        "Move between account details, identity verification, and recent investor activity.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.investorProfileKyc,
    popover: {
      title: "Identity verification",
      description:
        "Complete KYC here to unlock investments, marketplace orders, and other investor services.",
      side: "top",
      align: "start",
    },
  },
];

export const staffInvestHubSteps = [
  {
    element: TOUR_SELECTORS.staffInvestHubCards,
    popover: {
      title: "Hub overview",
      description:
        "These cards summarise funds requested, active opportunities, and items waiting on you.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffInvestHubAttention,
    popover: {
      title: "Needs attention",
      description:
        "Start here for KYC, requests, and other items that need a decision today.",
      side: "bottom",
      align: "start",
    },
  },
];

export const staffInvestOppsSteps = [
  {
    element: TOUR_SELECTORS.staffInvestOppsCreate,
    popover: {
      title: "Create an opportunity",
      description:
        "Draft a new offering, then submit it for review and publish when it is ready.",
      side: "bottom",
      align: "end",
    },
  },
  {
    element: TOUR_SELECTORS.staffInvestOppsList,
    popover: {
      title: "Opportunity list",
      description:
        "Search and filter offerings, then open a row to edit, publish, or archive.",
      side: "top",
      align: "start",
    },
  },
];

export const staffInvestRequestsSteps = [
  {
    element: TOUR_SELECTORS.staffInvestReqTabs,
    popover: {
      title: "Request queue",
      description:
        "Filter by status — submitted, under review, approved, and more — to work the queue.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffInvestReqQueue,
    popover: {
      title: "Review a request",
      description:
        "Open details to approve, decline, or follow payment and allocation status.",
      side: "top",
      align: "start",
    },
  },
];

export const staffInvestKycSteps = [
  {
    element: TOUR_SELECTORS.staffInvestKycQueue,
    popover: {
      title: "KYC reviews",
      description:
        "Filter pending and under-review submissions from standalone investors and members.",
      side: "bottom",
      align: "start",
    },
  },
  {
    element: TOUR_SELECTORS.staffInvestKycActions,
    popover: {
      title: "Approve or reject",
      description:
        "Open a submission to verify identity, then approve, reject, or request a resubmission.",
      side: "top",
      align: "start",
    },
  },
];

/** @type {Record<string, { id: string, role: string, match: (pathname: string) => boolean, steps: object[] }>} */
export const TOURS = {
  staff: {
    id: "staff",
    role: "staff",
    match: (pathname) => pathname === "/super_admin/dashboard",
    steps: staffDashboardSteps,
  },
  member: {
    id: "member",
    role: "member",
    match: (pathname) => pathname === "/member/dashboard",
    steps: memberDashboardSteps,
  },
  investor: {
    id: "investor",
    role: "investor",
    match: (pathname) => pathname === "/invest/dashboard",
    steps: investorDashboardSteps,
  },
  staff_contributions: {
    id: "staff_contributions",
    role: "staff",
    match: (pathname) =>
      pathname.startsWith("/super_admin/contribution/record_contribution"),
    steps: staffContributionsSteps,
  },
  staff_loans: {
    id: "staff_loans",
    role: "staff",
    match: (pathname) =>
      pathname === "/super_admin/loan_management/loan_status" ||
      pathname.startsWith("/super_admin/loan_management/loan_status/"),
    steps: staffLoansSteps,
  },
  member_contributions: {
    id: "member_contributions",
    role: "member",
    match: (pathname) =>
      pathname === "/member/contribution" || pathname === "/member/contribution/",
    steps: memberContributionsSteps,
  },
  member_loans: {
    id: "member_loans",
    role: "member",
    match: (pathname) =>
      pathname === "/member/loan_management" ||
      pathname === "/member/loan_management/",
    steps: memberLoansSteps,
  },
  staff_members: {
    id: "staff_members",
    role: "staff",
    match: (pathname) =>
      pathname === "/super_admin/member_management/members" ||
      pathname.startsWith("/super_admin/member_management/members?"),
    steps: staffMembersSteps,
  },
  member_attendance: {
    id: "member_attendance",
    role: "member",
    match: (pathname) =>
      pathname === "/member/attendance" || pathname === "/member/attendance/",
    steps: memberAttendanceSteps,
  },
  staff_attendance: {
    id: "staff_attendance",
    role: "staff",
    match: (pathname) =>
      pathname === "/super_admin/attendance" ||
      pathname === "/super_admin/attendance/",
    steps: staffAttendanceSteps,
  },
  member_profile: {
    id: "member_profile",
    role: "member",
    match: (pathname) =>
      pathname === "/member/profile" || pathname === "/member/profile/",
    steps: memberProfileSteps,
  },
  staff_settings: {
    id: "staff_settings",
    role: "staff",
    match: (pathname) => isExactPath(pathname, "/super_admin/settings/society_bank_info"),
    steps: staffSettingsSteps,
  },
  staff_staff_mgmt: {
    id: "staff_staff_mgmt",
    role: "staff",
    match: (pathname) => isExactPath(pathname, "/super_admin/staff_registration/view_staff"),
    steps: staffStaffMgmtSteps,
  },
  staff_communication: {
    id: "staff_communication",
    role: "staff",
    match: (pathname) => isExactPath(pathname, "/super_admin/communication"),
    steps: staffCommunicationSteps,
  },
  staff_events: {
    id: "staff_events",
    role: "staff",
    match: (pathname) => isExactPath(pathname, "/super_admin/event_calendar"),
    steps: staffEventsSteps,
  },
  staff_birthday: {
    id: "staff_birthday",
    role: "staff",
    match: (pathname) => isExactPath(pathname, "/super_admin/automated_birthday"),
    steps: staffBirthdaySteps,
  },
  staff_eminutes: {
    id: "staff_eminutes",
    role: "staff",
    match: (pathname) => isExactPath(pathname, "/super_admin/eminutes"),
    steps: staffEminutesSteps,
  },
  staff_transactions: {
    id: "staff_transactions",
    role: "staff",
    match: (pathname) => isExactPath(pathname, "/super_admin/transaction_history"),
    steps: staffTransactionsSteps,
  },
  staff_support: {
    id: "staff_support",
    role: "staff",
    match: (pathname) =>
      isExactPath(pathname, "/super_admin/admin") ||
      isExactPath(pathname, "/super_admin/settings/support_settings"),
    steps: staffSupportSteps,
  },
  staff_audit: {
    id: "staff_audit",
    role: "staff",
    match: (pathname) => isExactPath(pathname, "/super_admin/audit_log"),
    steps: staffAuditSteps,
  },
  staff_reports: {
    id: "staff_reports",
    role: "staff",
    match: (pathname) => isExactPath(pathname, "/super_admin/reports/sms_history"),
    steps: staffReportsSteps,
  },
  member_birthdays: {
    id: "member_birthdays",
    role: "member",
    match: (pathname) => isExactPath(pathname, "/member/birthdays"),
    steps: memberBirthdaysSteps,
  },
  member_transactions: {
    id: "member_transactions",
    role: "member",
    match: (pathname) => isExactPath(pathname, "/member/transaction_history"),
    steps: memberTransactionsSteps,
  },
  member_messages: {
    id: "member_messages",
    role: "member",
    match: (pathname) => isExactPath(pathname, "/member/communication"),
    steps: memberMessagesSteps,
  },
  member_events: {
    id: "member_events",
    role: "member",
    match: (pathname) => isExactPath(pathname, "/member/event"),
    steps: memberEventsSteps,
  },
  member_support: {
    id: "member_support",
    role: "member",
    match: (pathname) => isExactPath(pathname, "/member/support"),
    steps: memberSupportSteps,
  },
  member_eminutes: {
    id: "member_eminutes",
    role: "member",
    match: (pathname) => isExactPath(pathname, "/member/eminutes"),
    steps: memberEminutesSteps,
  },
  investor_investments: {
    id: "investor_investments",
    role: "investor",
    match: (pathname) => isExactPath(pathname, "/invest/investments"),
    steps: investInvestmentsSteps,
  },
  investor_marketplace: {
    id: "investor_marketplace",
    role: "investor",
    match: (pathname) => isExactPath(pathname, "/invest/marketplace"),
    steps: investMarketplaceSteps,
  },
  investor_requests: {
    id: "investor_requests",
    role: "investor",
    match: (pathname) => isExactPath(pathname, "/invest/requests"),
    steps: investRequestsSteps,
  },
  investor_notifications: {
    id: "investor_notifications",
    role: "investor",
    match: (pathname) => isExactPath(pathname, "/invest/notifications"),
    steps: investorNotificationsSteps,
  },
  investor_profile: {
    id: "investor_profile",
    role: "investor",
    match: (pathname) => isExactPath(pathname, "/invest/profile"),
    steps: investorProfileSteps,
  },
  member_invest_investments: {
    id: "member_invest_investments",
    role: "member",
    match: (pathname) => isExactPath(pathname, "/invest/investments"),
    steps: investInvestmentsSteps,
  },
  member_invest_marketplace: {
    id: "member_invest_marketplace",
    role: "member",
    match: (pathname) => isExactPath(pathname, "/invest/marketplace"),
    steps: investMarketplaceSteps,
  },
  member_invest_requests: {
    id: "member_invest_requests",
    role: "member",
    match: (pathname) => isExactPath(pathname, "/invest/requests"),
    steps: investRequestsSteps,
  },
  staff_invest_hub: {
    id: "staff_invest_hub",
    role: "staff",
    match: (pathname) => isExactPath(pathname, "/super_admin/investor_portal/dashboard"),
    steps: staffInvestHubSteps,
  },
  staff_invest_opps: {
    id: "staff_invest_opps",
    role: "staff",
    match: (pathname) =>
      isExactPath(pathname, "/super_admin/investor_portal/investments/opportunities"),
    steps: staffInvestOppsSteps,
  },
  staff_invest_requests: {
    id: "staff_invest_requests",
    role: "staff",
    match: (pathname) =>
      isExactPath(pathname, "/super_admin/investor_portal/investments/requests"),
    steps: staffInvestRequestsSteps,
  },
  staff_invest_kyc: {
    id: "staff_invest_kyc",
    role: "staff",
    match: (pathname) => isExactPath(pathname, "/super_admin/investor_portal/investors/kyc"),
    steps: staffInvestKycSteps,
  },
};

/** Keep only steps whose target exists in the DOM. */
export function filterAvailableSteps(steps) {
  if (typeof document === "undefined") return [];
  return (steps || []).filter((step) => {
    if (!step?.element) return true;
    return Boolean(document.querySelector(step.element));
  });
}

export function getTourById(tourId) {
  return TOURS[tourId] || null;
}

export function getDashboardTourId(role) {
  if (role === "member") return "member";
  if (role === "investor") return "investor";
  return "staff";
}

/**
 * Prefer a matching module tour for this role+path; else dashboard if on dashboard.
 */
export function resolveTourForPath(role, pathname) {
  const path = pathname || "";
  const moduleTours = Object.values(TOURS).filter(
    (t) => t.role === role && t.id !== role && t.match(path)
  );
  if (moduleTours.length > 0) return moduleTours[0];

  const dashboard = TOURS[getDashboardTourId(role)];
  if (dashboard?.match(path)) return dashboard;
  return null;
}

/** Help button: current module/dashboard tour, or role dashboard as fallback. */
export function resolveTourForHelp(role, pathname) {
  return (
    resolveTourForPath(role, pathname) ||
    TOURS[getDashboardTourId(role)] ||
    null
  );
}

// Backward-compatible helpers used by older call sites
export function getStepsForRole(role) {
  return TOURS[getDashboardTourId(role)]?.steps || staffDashboardSteps;
}

export function getDashboardPathForRole(role) {
  if (role === "member") return "/member/dashboard";
  if (role === "investor") return "/invest/dashboard";
  return "/super_admin/dashboard";
}
